import { Fetch, schemas } from "@convergence/client";
import { useMutation } from "@tanstack/react-query";

export async function requestOtp(email: string, fetch: Fetch) {
  return fetch(
    "/auth/otp",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    },
    schemas.RequestOtpResponse
  );
}

export async function login(otp: string, fetch: Fetch) {
  return fetch(
    "/auth/login",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ otp }),
    },
    schemas.LoginResponse
  );
}

export const useRequestOtp = (fetch: Fetch) => {
  return useMutation({
    mutationKey: ["requestOtp"],
    mutationFn: (email: string) => requestOtp(email, fetch),
  });
};

export const useLogin = (fetch: Fetch) => {
  return useMutation({
    mutationKey: ["login"],
    mutationFn: (otp: string) => login(otp, fetch),
  });
};
